const t=new Map,c=(o,n)=>(t.set(o,n),n);export{c as icon,t as icons};
